<div style="display: flex; height: 50px;" >
  <h1 style="flex:80%">Overige Informatie</h1>
</div>

<ng-container>
  <ion-item>
    <div class="card-container">
      <h2>Wilt u uw gegevens automatisch invullen?</h2>
      <p>Dit kunt u doen via de Belastingdienst. U download het VIA bestand en upload in onze app .</p>
      
      <ion-button class="via-upload-button" expand="block" (click)="goToBelastingdienst()">
          <ion-label class="via-upload-button-label">Open de Belastingdienst pagina</ion-label>
      </ion-button>
      <ion-button class="via-upload-button" expand="block" (click)="viaUpload()">
          <ion-label class="via-upload-button-label">Upload VIA file</ion-label>
      </ion-button>
      <p *ngIf="has_File"><ion-icon name="checkmark-done" class="tik"></ion-icon></p>
    </div>
  </ion-item>
  <ion-item>
    <div class="label-group">
        <ion-label class="ion-text" position="stacked">Rente</ion-label>
    </div>

    <ion-input type="number" step="0.01" class="ion-input-list" [(ngModel)]="interest">
    </ion-input>


    <div class="label-group">
        <ion-label class="ion-text" step="1" position="stacked">Rentevastperiode</ion-label>
    </div>

    <ion-input type="number" class="ion-input-list" [(ngModel)]="interest_lock_period">
    </ion-input>

    <div class="label-group">
      <ion-label class="ion-text" position="stacked">Start Datum</ion-label>
  </div>

  <ion-input type="date" class="ion-input-list" [(ngModel)]="start_date">
  </ion-input>


  <div class="label-group">
      <ion-label class="ion-text" position="stacked">Eind Datum</ion-label>
  </div>

  <ion-input type="date" class="ion-input-list" [(ngModel)]="end_date">
  </ion-input>
  </ion-item>
  <ion-item>
    
    <ion-button class="modal-button" (click)="SendData()" [disabled]="!has_File">BEVESTIGEN</ion-button>
  </ion-item>
</ng-container>